"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORD = exports.TYPE_VALUE = exports.TYPE_TERM = exports.TYPE_STRING = exports.TYPE_OBJECT = exports.TYPE_NULL = exports.TYPE_ARRAY = exports.TURN = exports.SPEAKER_COLOR_2 = exports.SPEAKER_COLOR_1 = exports.SPEAKER_COLORS = exports.PUNC = exports.DEFAULT_SPEAKER = exports.DEFAULT_RANGE = void 0;
var DEFAULT_SPEAKER = 'Speaker';
exports.DEFAULT_SPEAKER = DEFAULT_SPEAKER;
var PUNC = 'punc';
exports.PUNC = PUNC;
var TURN = 'turn';
exports.TURN = TURN;
var WORD = 'word';
exports.WORD = WORD;
var DEFAULT_RANGE = 'marked';
exports.DEFAULT_RANGE = DEFAULT_RANGE;
var TYPE_TERM = 'Term';
exports.TYPE_TERM = TYPE_TERM;
var TYPE_ARRAY = 'array';
exports.TYPE_ARRAY = TYPE_ARRAY;
var TYPE_OBJECT = 'object';
exports.TYPE_OBJECT = TYPE_OBJECT;
var TYPE_STRING = 'string';
exports.TYPE_STRING = TYPE_STRING;
var TYPE_VALUE = 'value'; // NONE OF THE OTHER TYPES

exports.TYPE_VALUE = TYPE_VALUE;
var TYPE_NULL = 'null';
exports.TYPE_NULL = TYPE_NULL;
var SPEAKER_COLOR_1 = '#9aca62';
exports.SPEAKER_COLOR_1 = SPEAKER_COLOR_1;
var SPEAKER_COLOR_2 = '#0079c0';
exports.SPEAKER_COLOR_2 = SPEAKER_COLOR_2;
var SPEAKER_COLORS = [SPEAKER_COLOR_1, SPEAKER_COLOR_2, 'red'];
exports.SPEAKER_COLORS = SPEAKER_COLORS;